AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Views", "Profile");

AoPS.Alcumus.Views.Profile = (function (AlcVProfile) {
	// Dependencies
	var compileTemplate = AoPS.View.compileTemplate;
	var Modal = AoPS.Ui.Modal;
	var AlcUrl = AoPS.Alcumus.Url;
	var AlcVBase = AoPS.Alcumus.Views.Base;
	var AlcVSubject = AoPS.Alcumus.Views.Subject;

	AlcVProfile.MainPanel = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-profile-main-panel");

			this.model.requestLoad(function (ok, data) {
				if (!ok) {
					return this.renderError(data);
				}

				this.generateSubviews();
				this.listenTo(this.model, "change", this.render);
				this.render();
			}, this);
			this.renderLoading();
		},

		generateSubviews: function () {
			if (!this.model.canSeeProfile()) {
				return;
			}

			var view_obj;

			view_obj = new AlcVProfile.RatingInfo({
				model: this.model,
				is_large: true,
			});
			this.addSubviewToLocation(view_obj, "@main_rating");

			this.model.get("subjects").each(function (model) {
				view_obj = new AlcVProfile.RatingInfo({model: model});
				this.addSubviewToLocation(view_obj, "@subject_ratings");
			}, this);

			view_obj = new AlcVProfile.AstatBonusInfo({
				model: this.model.get("astats").get(4),
			});
			this.addSubviewToLocation(view_obj, "@astat_ratings");

			this.model.get("astats").each(function (model) {
				view_obj = new AlcVProfile.AstatInfo({model: model});
				this.addSubviewToLocation(view_obj, "@astat_ratings");
			}, this);

			view_obj = new AlcVProfile.Summary({model: this.model});
			this.addSubviewToLocation(view_obj, "@summary");
		},

		getContext: function () {
			var avatar_data = this.model.get("avatar_data");

			return {
				username: this.model.get("username"),
				avatar_url: avatar_data && avatar_data[0],
				avatar_width: avatar_data && avatar_data[1],
				avatar_height: avatar_data && avatar_data[2],
				can_see_profile: this.model.canSeeProfile(),
				is_private: this.model.get("is_private"),
				is_uninitialized: this.model.get("is_uninitialized"),
			};
		},

		// The XP bar rendering only works when the element is in the page; this
		// forces a recomputation whenever this view is brought up.
		onAddToPage: function () {
			this.applyToAllSubviews(function (location, subview) {
				subview.rerenderBar && subview.rerenderBar();
			});
		},
	});

	// Can pass in user model (shows overall rating) or a subject model.
	AlcVProfile.RatingInfo = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-profile-rating-info");

			this.is_large = !!options.is_large;

			this.clearLocation("@xp_bar");
			this.xp_bar = new AlcVSubject.XpBar({model: this.model});
			this.addSubviewToLocation(this.xp_bar, "@xp_bar");

			this.listenTo(this.model, "change", this.render);
			this.render();
		},

		isMe: function () {
			var user_model = this.model.get("user") || this.model;
			return user_model.get("is_me");
		},

		getScoreColor: function (score) {
			if (score >= 75) {
				return "aops-rogb-blue";
			} else if (score >= 50) {
				return "aops-rogb-green";
			} else if (score >= 25) {
				return "aops-rogb-orange";
			} else {
				return "aops-rogb-red";
			}
		},

		getContext: function () {
			var name =
				this.model.model_type === "subject"
					? this.model.get("name")
					: "Overall";
			// Round to one decimal
			var score = parseFloat(
				Math.round(10 * this.model.get("score")) / 10
			).toFixed(1);
			return {
				is_large: this.is_large,
				score_color_class: this.getScoreColor(score),
				name: name,
				score: score,
			};
		},

		postRender: function () {
			if (this.isMe()) {
				this.$(".alc--name")
					.addClass("alc-pointer")
					.click(_.bind(this.onClickName, this));
			}
		},

		rerenderBar: function () {
			this.xp_bar.updateBarAndLabel();
		},

		onClickName: function () {
			if (!this.isMe()) {
				// Do nothing
			} else if (this.model.model_type === "subject") {
				Backbone.trigger(
					"alc_goto_url",
					AlcUrl.getUrl("report_subject", "me", this.model.id)
				);
			} else {
				Backbone.trigger("alc_goto_url", AlcUrl.getUrl("report", "me"));
			}
		},
	});

	AlcVProfile.AstatInfo = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-profile-astat-info");

			this.clearLocation("@xp_bar");
			this.xp_bar = new AlcVSubject.XpBar({model: this.model});
			this.addSubviewToLocation(this.xp_bar, "@xp_bar");

			this.listenTo(this.model, "change", this.render);
			this.render();
		},

		events: {
			"click .alc--info": "onInfo",
		},

		getInfo: function () {
			var infoTpl = compileTemplate(
				"#alc-cms-profile-info-" + this.model.get("code")
			);
			return infoTpl();
		},

		onInfo: function () {
			Modal.showAlert(this.getInfo());
		},

		getContext: function () {
			return {
				name: this.model.get("name"),
				description: _.trim(this.getInfo()),
			};
		},

		rerenderBar: function () {
			this.xp_bar.updateBarAndLabel();
		},
	});

	AlcVProfile.AstatBonusInfo = AlcVBase.BaseView.extend({
		BAR_COUNT: 20,

		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-profile-astat-bonus-info");

			this.listenTo(this.model, "change", this.render);
			this.render();
		},

		events: {
			"click .alc--info": "onInfo",
		},

		getInfo: function () {
			var infoTpl = compileTemplate("#alc-cms-profile-info-bonus");
			return infoTpl();
		},

		onInfo: function () {
			Modal.showAlert(this.getInfo());
		},

		getContext: function () {
			return {
				name: "XP Bonus",
				description: this.getInfo(),
			};
		},

		postRender: function () {
			var bar_container = this.$(".alc-astat-bonus-bars");
			var bar = this.$(".alc-astat-bonus-bars > div").first();
			// i measures how many bars there are currently
			for (var i = 1; i < this.BAR_COUNT; i += 1) {
				bar.after(bar.clone());
			}

			var full_bars = Math.floor(
				(this.BAR_COUNT * this.model.get("bonus")) / 100
			);
			bar_container.children().each(function (j) {
				if (j < full_bars) {
					$(this).addClass("alc--full");
				}
			});
		},
	});

	AlcVProfile.Summary = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-profile-summary");

			var view_obj = new AlcVProfile.ProblemWheel({
				model: this.model.get("problem_stats"),
			});
			this.addSubviewToLocation(view_obj, "@problem_wheel");

			this.listenTo(this.model, "change", this.render);
			this.render();
		},

		getContext: function () {
			return {
				max_correct_streak: this.model.get("max_correct_streak"),
				max_day_streak: this.model.get("max_day_streak"),
				topics_passed: this.model.get("topics_passed"),
				topics_mastered: this.model.get("topics_mastered"),
				total_days: this.model.get("total_days"),
				total_quests: this.model.get("total_quests"),
				total_achievements: this.model.get("total_achievements"),
			};
		},
	});

	// Feed in a problem_stats model
	AlcVProfile.ProblemWheel = AlcVBase.BaseView.extend({
		// Copied from rogb.css. In ROGB order.
		color_list: ["#E2002B", "#ef7f00", "#3da000", "#1496d8"],

		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-profile-problem-wheel");

			this.margin = options.margin || 8;
			this.outer_radius = options.outer_radius || 72;
			this.inner_radius = options.inner_radius || 48;

			this.listenTo(this.model, "change", this.render);
			this.render();
		},

		getContext: function () {
			var model = this.model;
			return {
				total: model.get("total"),
				first: model.get("first"),
				second: model.get("second"),
				incorrect: model.get("incorrect"),
				giveup: model.get("giveup"),
				canvas_size: 2 * this.outer_radius + 2 * this.margin,
			};
		},

		// Returns 5-element array: [-Math.PI/2, ang1, ang2, ang3, 3*Math.PI/2].
		// ang1 is the angle dividing red/orange (giveup/wrong).
		// ang2 is the angle dividing orange/green (wrong/second).
		// ang3 is the angle dividing green/blue (second/first).
		computeAngles: function () {
			var pi = Math.PI;
			var total = this.model.get("total");
			var ang0 = -pi / 2;
			var ang1 = ang0 + (2 * pi * this.model.get("giveup")) / total;
			var ang2 = ang1 + (2 * pi * this.model.get("incorrect")) / total;
			var ang3 = ang2 + (2 * pi * this.model.get("second")) / total;
			return [ang0, ang1, ang2, ang3, ang0 + 2 * pi];
		},

		// Set the title attribute of the element. Done here because the root
		// element rendering hack means this won't get updated in future renders.
		setTooltip: function () {
			var model = this.model;
			var tooltip = model.get("first") + " right in one try. \n";
			tooltip += model.get("second") + " right in two tries. \n";
			tooltip += model.get("incorrect") + " wrong. \n";
			tooltip +=
				model.get("giveup") +
				" give-up" +
				(parseInt(model.get("giveup")) === 1 ? "" : "s") +
				".";
			this.$el.attr("title", tooltip);
		},

		postRender: function () {
			this.setTooltip();

			var canvas = this.$("canvas");
			if (!canvas.length || !canvas[0].getContext) {
				return;
			}
			var context = canvas[0].getContext("2d");
			var or = this.outer_radius;
			var ir = this.inner_radius;

			context.clearRect(0, 0, 2 * or, 2 * or);
			context.translate(or + this.margin, or + this.margin);

			// Shadow
			context.save();
			context.fillStyle = "#fff";
			context.shadowColor = "#ccc";
			context.shadowOffsetX = 2;
			context.shadowOffsetY = 6;
			context.shadowBlur = 15;
			context.beginPath();
			context.moveTo(or, 0);
			context.lineTo(ir, 0);
			context.arc(0, 0, ir, 0, 2 * Math.PI, false);
			context.lineTo(or, 0);
			context.arc(0, 0, or, 0, 2 * Math.PI, true);
			context.fill();
			context.restore();

			// Main colors
			var angles = this.computeAngles();
			for (var i = 0; i < angles.length - 1; i += 1) {
				if (angles[i] === angles[i + 1]) {
					continue;
				}

				context.fillStyle = this.color_list[i];
				context.beginPath();
				context.moveTo(or * Math.cos(angles[i]), or * Math.sin(angles[i]));
				context.lineTo(ir * Math.cos(angles[i]), ir * Math.sin(angles[i]));
				context.arc(0, 0, ir, angles[i], angles[i + 1], false);
				context.lineTo(
					or * Math.cos(angles[i + 1]),
					or * Math.sin(angles[i + 1])
				);
				context.arc(0, 0, or, angles[i + 1], angles[i], true);
				context.fill();
			}
		},
	});

	AlcVProfile.BottomPanel = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-profile-bottom-panel");

			this.model.requestLoad(function (ok, data) {
				if (!ok) {
					return this.renderError(data);
				}

				this.panels = {
					quests: new AlcVProfile.QuestPanel({
						model: this.model,
						for_achievements: false,
					}),
					achievements: new AlcVProfile.QuestPanel({
						model: this.model,
						for_achievements: true,
					}),
					friends: new AlcVProfile.FriendPanel({
						model: this.model,
					}),
				};

				this.updatePanelVisibility("quests");
				_.each(
					this.panels,
					function (panel_view) {
						this.addSubviewToLocation(panel_view, "@main_panel");
					},
					this
				);

				this.render();
			}, this);

			this.renderLoading();
		},

		events: {
			"click .alc--page-button": "onChangePage",
		},

		updatePanelVisibility: function (shown_page) {
			this.active_page = shown_page || this.active_page;
			_.each(
				this.panels,
				function (panel_view, page) {
					panel_view.$el.toggle(page === shown_page);

					if (page === "friends" && page === shown_page) {
						panel_view.startListeners();
					} else if (page === "friends") {
						panel_view.stopListeners();
					}
				},
				this
			);
		},

		onChangePage: function (evt) {
			var button = $(evt.currentTarget);
			if (button.hasClass("alc--quests")) {
				this.updatePanelVisibility("quests");
			} else if (button.hasClass("alc--achievements")) {
				this.updatePanelVisibility("achievements");
			} else if (button.hasClass("alc--friends")) {
				this.updatePanelVisibility("friends");
			}

			this.$(".alc--page-button").removeClass("alc--active");
			button.addClass("alc--active");
		},
	});

	AlcVProfile.QuestPanel = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-profile-bottom-subpanel");
			this.for_achievements = options && options.for_achievements;

			this.model.requestQuestsLoad(function (ok, data) {
				if (!ok && data.error_code === "E_NO_AUTH") {
					return this.renderSimple(
						"You must be this user's friend in order to view their quests and achievements."
					);
				} else if (!ok) {
					return this.renderError(data);
				}
				this.listenTo(
					this.model.get("quests"),
					this.COLLECTION_CHANGE + "change",
					function () {
						this.generateItems();
						this.render();
					}
				);

				this.generateItems();
				this.render();
			}, this);

			this.renderLoading();
		},

		generateItems: function () {
			this.clearLocation("@items");
			function createSubview(model) {
				var view_obj = new AlcVProfile.QuestItem({model: model});
				this.addSubviewToLocation(view_obj, "@items");
			}

			var quests = this.model.get("quests").where({
				is_achievement: !!this.for_achievements,
			});
			// Each quest type might need to create multiple subviews, so we
			// have nested each calls.
			_.each(
				quests,
				function (model) {
					_.each(model.getListModels(), createSubview, this);
				},
				this
			);
			return true;
		},
	});

	AlcVProfile.QuestItem = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-profile-quests-item");

			this.listenTo(this.model, "change", this.render);
			this.render();
		},

		events: {
			click: "showDetails",
		},

		getContext: function () {
			var model = this.model;

			return {
				is_assigned: model.get("is_assigned"),
				is_completed: model.get("is_completed"),
				badge_data: model.getBadgeData(),
				name: model.get("name") || "???",
				description: model.get("description") || "???",
			};
		},

		showDetails: function () {
			// This is the model for this level
			var model = this.model;
			// This is the model for the quest itself
			var quest = model.get("quest");
			// This is the user owning both
			var user = quest.get("user");
			// Don't show details of hidden achievements.
			if (!model.get("description") && !model.get("is_completed")) {
				return;
			}

			var modalTpl = compileTemplate("#alc-tpl-profile-quests-details");
			Modal.showAlert(
				modalTpl({
					is_me: user.get("is_me"),
					username: user.get("username"),

					badge_data: model.getBadgeData(),
					name: model.get("name"),
					description: model.get("description"),
					progress: model.get("progress"),

					has_data: model.get("is_assigned") || model.get("is_completed"),
					is_achievement: quest.get("is_achievement"),
					is_assigned: model.get("is_assigned"),
					is_completed: model.get("is_completed"),

					finished_at: moment(model.get("finished_at")).format(
						"h:mm A [of] MMMM D, YYYY"
					),
					show_times_completed: model.get("level") >= quest.get("level_count"),
					times_completed: quest.get("times_completed"),
					previous_names:
						model.get("is_completed") && model.getPreviousNamesString(),

					xp_bonus: quest.get("times_completed") && model.get("xp_bonus"),
					xp_is_for_last:
						quest.get("times_completed") > 1 || model.get("is_assigned"),
					users_completed: model.get("users_completed"),
				})
			);
		},
	});

	// RR changed basically everything here.
	AlcVProfile.FriendPanel = AlcVBase.BaseView.extend({
		friend_click_path: "/profile/",

		router_base: "/alcumus",

		initialize: function (options) {
			if (!AoPS.Community) {
				this.$el.html(
					"Friends cannot be displayed because the community is not loaded"
				);
				return;
			}

			var no_friends_message = this.model.get("is_me")
				? 'You currently do not have any AoPS friends.  Visit your <a href="/community/my-aops">Community My AoPS page</a> to manage your AoPS friends.'
				: "This user has no AoPS friends yet.";
			this.setTemplateAndUseRootEl("alc-tpl-profile-bottom-subpanel");
			this.$friends_box = this.$el;
			this.$no_friends = $(
				'<div class="cmty-no-friends cmty-alc-friends-message">' +
					no_friends_message +
					"</div>"
			);

			this.$el.addClass("alc-profile-bottom-subpanel");
			this.$loader = AoPS.Page.buildLoader();
			this.is_session_user = false;
			if (this.model.get("friends_exclude")) {
				this.$el.append(
					'<span class="cmty-alc-friends-message">This user has chosen to be excluded from the AoPS friends system.</span>'
				);
			} else if (
				!this.model.get("is_me") &&
				!this.model.get("friends_show_profile")
			) {
				this.$el.append(
					'<span class="cmty-alc-friends-message">This user\'s friend list is not public.</span>'
				);
			} else {
				this.buildFriends();
			}
		},

		buildFriends:
			AoPS.Community && AoPS.Community.Views.UserProfile.prototype.buildFriends,

		startListeners:
			AoPS.Community &&
			AoPS.Community.Views.UserProfile.prototype.startListeners,

		buildFriendBox:
			AoPS.Community &&
			AoPS.Community.Views.UserProfile.prototype.buildFriendBox,

		stopListeners:
			AoPS.Community &&
			AoPS.Community.Views.UserProfile.prototype.stopListeners,
	});

	AlcVProfile.FriendItem = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-profile-friend-item");

			this.data = options.data;
			this.render();
		},

		events: {
			click: "gotoProfile",
		},

		getContext: function () {
			return {
				user_id: this.data.user_id,
				avatar_url: this.data.avatar,
				username: this.data.username,
				activity: this.data.statuses,
			};
		},

		gotoProfile: function () {
			Backbone.trigger(
				"alc_goto_url",
				AlcUrl.getUrl("profile", this.data.user_id)
			);
		},
	});

	return AlcVProfile;
})(AoPS.Alcumus.Views.Profile);
